
// dialog
const dialog = document.getElementById('dialog-images');
const closeDialogButton = document.getElementById('close-dialog');
const openSlideshow = document.getElementById('open-slideshow');

// open dialog
function openDialog() {

    // show dialog
    dialog.showModal();    

    // add class no-scroll to html
    document.documentElement.classList.add('no-scroll');

}

// close dialog
function closeDialog() {

    dialog.close();

    // remove class no-scroll from html
    document.documentElement.classList.remove('no-scroll');

}

// event listeners
if (openSlideshow){
    openSlideshow.addEventListener('click', openDialog);
    closeDialogButton.addEventListener('click', closeDialog);
}